<template>
  <v-container fluid>
    <div :class="cualClaseRetornar">
      <v-row no-gutters>
        <v-col cols="12">
          <div style="display: flex;justify-content: space-between;">
            <div class="tabla">
              This invoice must be completed in English
            </div>
            <div style="font-size:20px;font-weight:bold;">
              <div v-if="totalValorEnvio <= 115">Pro Forma Invoice</div>
              <div v-else>Commercial Invoice</div>
            </div>
            <div class="tabla">
              Page 1 of 1 .
            </div>
          </div>

          <v-simple-table class="borde tabla" dense>
            <tbody>
              <tr class="borde">
                <td class="borde" colspan="10" style="padding:15px;">
                  <div class="tabla">
                    EXPORTER<br />
                    Tax ID: {{ infoDespues.TAXIDREMITENTE || "UNKNOWN" }} <br />
                    Contact name: <span class="spacer"></span>
                    {{ infoDespues.TITULARDOCUMENTO || infoCI.Exporter.nombre || "" }}<br />
                    Telephone No.: {{ infoCI.Exporter.telefono || "" }}<br />
                    Email: rufasa08@yahoo.com.mx <br />
                    Company Name Address:
                    <br />
                    {{
                      infoCI.Exporter.razonSocial ||
                        infoDespues.TITULARDOCUMENTO ||
                        infoCI.Exporter.nombre ||
                        ""
                    }}
                    <br />
                    {{ infoDespues.DIRECCION || direccionSucursalFormateada || " - " }}
                    <br />
                    Country/Territory: MEXICO<br />
                    Parties to Transaction: <br />
                    <div style="display:flex;">
                      <input type="checkbox" /> Related
                      <div style="width:50px;"></div>
                      <input type="checkbox" checked /> No related
                    </div>
                  </div>
                </td>
                <td class="borde" style="vertical-align:top" colspan="10">
                  <div class="tabla">
                    Ship date:<br />
                    {{ infoCI.fechaSuperior || "" }}

                    Air Waybill No./ Tracking No<br />
                    <span style="font-weight:bold;">{{ infoCI.guiaPrimerPaquete || "N/A" }}</span
                    ><br />
                    <div style="display: flex;">
                      Invoice No.
                      <div style="width:150px;"></div>
                      Purchase Order No:
                    </div>
                    <div style="display: flex;">
                      Payment Terms.
                      <div style="width:120px;"></div>
                      Bill of lading
                    </div>

                    Purpose of shipment<br />
                    <div v-if="totalValorEnvio <= 115">
                      SAMPLE
                    </div>
                    <div v-else>
                      COMMERCIAL
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="borde" colspan="10">
                  <div class="tabla">
                    CONSIGNEE <br />
                    Tax ID: {{ infoDespues.TAXIDDESTINATARIO || "UNKNOWN" }} <br />
                    Contact name: {{ infoCI.Consignee.nombre || "" }}<br />
                    Telephone No.: {{ infoCI.Consignee.telefono || "" }}<br />
                    Email: <br />
                    Company Name/Address:
                    <br />
                    {{ infoCI.Consignee.razonSocial || infoCI.Consignee.nombre || "" }}
                    <br />
                    {{ infoCI.Consignee.direccion || "" }}
                    <!-- {{infoDespues.DIRECCION || ' - '}} -->
                    <br />
                    <br />
                    Country/Territory: {{ infoCI.Consignee.pais }}
                  </div>
                </td>
                <td class="borde" style="vertical-align:top" colspan="10">
                  <div class="tabla">
                    Sold To/Importer (if different from Consignee)<br />
                    <pre> <input type="checkbox" id="marcar1" checked>Same as              CONSIGNE</pre>
                    Tax ID# UNKNOWN<br />
                    Company name address <br />
                    Country/Territory: {{ infoCI.Consignee.pais }}
                  </div>
                </td>
              </tr>
            </tbody>
            <tr>
              <td class="borde" colspan="20">
                If there is a designated broker for this shipment, please provide contact
                information.
                <br />
                <div style="display:flex;">
                  Name of Broker
                  <div style="width:200px;"></div>
                  Tel.No.
                  <div style="width:200px;"></div>
                  Contact Name
                </div>
                <div style="display:flex;">
                  Duties and Taxes Payble by:
                  <div style="width:20px;"></div>
                  <input type="checkbox" /> Exporter
                  <div style="width:20px;"></div>
                  <input type="checkbox" checked /> Consignee
                  <div style="width:20px;"></div>
                  <input type="checkbox" /> Other
                  <div style="width:50px;"></div>
                  If other, please specify
                </div>
              </td>
            </tr>
            <tr>
              <td class="borde" colspan="2">No. Of Packages</td>
              <td class="borde" colspan="2">No.of Units</td>
              <td class="borde" colspan="2">Net Weight (LBS/KGS)</td>
              <td class="borde" colspan="2">Unit, of Masure</td>
              <td class="borde" colspan="4">Description Of Goods</td>
              <td class="borde" colspan="2">Harmonized Tariff Number</td>
              <td class="borde" colspan="2">Country of Manufacture</td>
              <td class="borde" colspan="2">Unit Value</td>
              <td class="borde" colspan="2">Total Value</td>
            </tr>
            <tr v-for="(item, index) in infoCI.fraccionesIterables" :key="index">
              <!-- este es el 1 que se debe cambiar -->
              <!-- <td class="borde pl-1" colspan="2">{{ item.noPaquete }}</td> -->
              <td class="borde pl-1" colspan="2">1</td>
              <td class="borde pl-1" colspan="2">{{ parseFloat(item.cantidad) }}</td>
              <td class="borde pl-1" colspan="2">0.00</td>
              <td class="borde pl-1" colspan="2">PCS</td>
              <td class="borde pl-1" colspan="4">{{ item.des_en.toUpperCase() }}</td>
              <td class="borde pl-1" colspan="2">{{ item.num_clasificacion }}</td>
              <td class="borde pl-1" colspan="2">MX</td>
              <td class="borde pl-1" colspan="2">
                {{ parseFloat(item.valor_unitario).toFixed(2) }}
              </td>
              <td class="borde pl-1" colspan="2">
                {{ parseFloat(item.valor_unitario * item.cantidad).toFixed(2) }}
              </td>
            </tr>
            <tr v-for="(item, index) in 8 - infoCI.fraccionesIterables.length" :key="index + 'b'">
              <td class="borde" colspan="2"></td>
              <td class="borde" colspan="2">-</td>
              <td class="borde" colspan="2"></td>
              <td class="borde" colspan="2"></td>
              <td class="borde pl-1" colspan="4">-</td>
              <td class="borde pl-1" colspan="2">-</td>
              <td class="borde" colspan="2"></td>
              <td class="borde pl-1" colspan="2">-</td>
              <td class="borde" colspan="2"></td>
            </tr>
            <!-- renglon con instrucciones especiales -->
            <tr>
              <td class="borde" colspan="2"></td>
              <td class="borde pl-1" colspan="2">-</td>
              <td class="borde" colspan="2"></td>
              <td class="borde" colspan="2"></td>
              <td class="borde pl-1" colspan="4">
                <div v-if="totalValorEnvio <= 115">
                  Special Instruction:<br />
                  UNSOLICITED GIFT REGALO NO SOLICITADO
                </div>
                <div v-else>
                  Special Instruction:
                  <span style="font-weight:bold;">
                    certificación de origen T-MEC adjunto en la factura. T-MEC certififaction of
                    origin attached to the invoice.</span
                  >
                </div>
              </td>
              <td class="borde" colspan="2">-</td>
              <td class="borde" colspan="2"></td>
              <td class="borde" colspan="2">-</td>
              <td class="borde" colspan="2"></td>
            </tr>
            <tr>
              <td class="borde" colspan="2"></td>
              <td class="borde" colspan="2"><span style="color:white;">d</span></td>
              <td class="borde" colspan="2"></td>
              <td class="borde" colspan="2"></td>
              <td class="borde" colspan="4"></td>
              <td class="borde" colspan="2"></td>
              <td class="borde" colspan="2"></td>
              <td class="borde" colspan="2"></td>
              <td class="borde" colspan="2"></td>
            </tr>
            <!-- renglon A importante -->
            <tr>
              <td class="borde pl-1" colspan="2">Total Pkgs</td>

              <td class="borde pl-1" colspan="2">Total Units</td>

              <td class="borde pl-1" colspan="4">Total Net Weight (iIndicate LBS/KGS)</td>
              <td class="borde pl-1" colspan="2">Total Gross Weight (Indicate LBS/KGS)</td>
              <td class="borde pl-1" colspan="6" rowspan="2">Terms fca of Sale.</td>
              <td class="borde pl-1" colspan="2">Subtotal</td>
              <td class="borde pl-1" colspan="2">{{ totalValorEnvio }}</td>
            </tr>
            <!-- renglon B importante -->
            <tr>
              <!-- total de paquetes -->
              <td class="borde pl-1" colspan="2">{{ infoCI.totalPaquetes }}</td>
              <td class="borde pl-1" colspan="2">{{ infoCI.totalUnidades }}</td>
              <td class="borde pl-1" colspan="4"><div class="ml-5">KG</div></td>
              <td class="borde pl-1" colspan="2">
                <span style="font-weight:bold;"> {{ infoCI.totalKilos.toFixed(2) }} </span> KG
              </td>
              <td class="borde pl-1" colspan="2">Insurance</td>
              <td class="borde pl-1" colspan="2">0.0</td>
            </tr>

            <tr>
              <td class="borde pl-1" colspan="18" rowspan="2">
                Special Instrucions:<br />
                <span style="font-weight:bold;">{{ infoCI.referenciaIPS }}</span>
              </td>
              <td class="borde pl-2">Freight</td>
              <td class="borde pl-2">0.00</td>
            </tr>
            <tr>
              <td class="borde pl-2">Packing</td>
              <td class="borde pl-2">0.00</td>
            </tr>
            <tr>
              <td class="borde pl-1" colspan="18" rowspan="2">
                Declaration statement
              </td>
              <td class="borde pl-2">Handling</td>
              <td class="borde pl-2">0.00</td>
            </tr>
            <tr>
              <td class="borde pl-2">Other</td>
              <td class="borde pl-2">0.00</td>
            </tr>
            <tr>
              <td class="borde pl-1" colspan="18">
                I declare that all the information contained in this invoice to be true and correct.
              </td>
              <td class="borde pl-2">Invoice Total:</td>
              <td class="borde pl-2">{{ totalValorEnvio }}</td>
            </tr>
            <tr>
              <td class="borde pl-1" colspan="18">
                Originator or name/ of company representative if the invoice is being completed on
                behalf of a company of individual: <br />
                {{ infoDespues.TITULARDOCUMENTO || infoCI.Exporter.nombre || "" }}
              </td>
              <td class="borde pl-1">Currency Code</td>
              <td class="borde pl-1">USD</td>
            </tr>
            <tr>
              <td class="borde pl-1" colspan="20">
                <div style="height:50px;"></div>
                <div style="display:flex;">
                  Signature/Title/Date
                  <div style="width:800px;"></div>
                  {{ infoCI.fechaInferior }}
                </div>
              </td>
            </tr>
            <tr style="visibility:hidden;height:0px;">
              <td style="width:3%;">1</td>
              <td style="width:3%;">2</td>
              <td style="width:3%;">3</td>
              <td style="width:3%;">4</td>
              <td style="width:3%;">5</td>
              <td style="width:3%;">6</td>
              <td style="width:3%;">7</td>
              <td style="width:3%;">8</td>

              <td style="width:9%;">9</td>
              <td style="width:2%;">10</td>
              <td style="width:2%;">11</td>
              <td style="width:9%;">12</td>

              <td style="width:3%;">13</td>
              <td style="width:3%;">14</td>
              <td style="width:3%;">15</td>
              <td style="width:3%;">16</td>
              <td style="width:3%;">17</td>
              <td style="width:3%;">18</td>
              <td style="width:3%;">19</td>
              <td style="width:3%;">20</td>
            </tr>
          </v-simple-table>

          <div style="display: flex;flex-direction: row-reverse;">
            <div style="font-size:10px;">
              REV.04.10.13-1.08
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
moment.locale("en");
export default {
  data() {
    return {
      fechaConvertida: "",
      fechaConvertidaCorta: ""
    };
  },
  mounted() {
    const myMomentObject = moment(this.infoCI.fechaEnvio, "DD-MM-YYYY");
    this.fechaConvertida = moment(myMomentObject).format("LL");
    this.fechaConvertidaCorta = moment(myMomentObject).format("ll");
  },
  computed: {
    ...mapState("documentosInternacional", {
      //infoDocumentoCommercialInvoice
      infoCI: state => state.infoDocumentoCommercialInvoice,
      infoDespues: state => state.infoDespues
    }),
    ...mapState("sesion", {
      sucursalInfo: state => state.sucursalData
    }),
    cualClaseRetornar() {
      if (this.totalValorEnvio <= 115) {
        return "marco";
      } else {
        return "marco2";
      }
    },
    direccionSucursalFormateada() {
      return (
        this.sucursalInfo.DIRECCION +
        " " +
        this.sucursalInfo.COLONIA +
        " " +
        this.sucursalInfo.CODIGO_POSTAL +
        " " +
        this.sucursalInfo.MUNICIPIO +
        " " +
        this.sucursalInfo.ESTADO
      ).toUpperCase();
    },
    totalValorEnvio() {
      let costoTotal = this.infoCI.fraccionesIterables.reduce(
        (a, b) => a + b.cantidad * b.valor_unitario,
        0
      );
      return costoTotal.toFixed(2);
    }
    // fraccionesSinRepetir() {
    //   const sinRepetir = JSON.parse(
    //     JSON.stringify(this.infoCI.infoCI.fraccionesIterables)
    //   ).reduce((a, b) => {
    //     if (a[b.id]) {
    //       a[b.id].cantidad = parseFloat(a[b.id].cantidad) + parseFloat(b.cantidad);
    //     } else a[b.id] = b;
    //     return a;
    //   }, {});

    //   const agrupados = Object.values(sinRepetir);

    //   return agrupados;
    // }
  }
};
</script>
<style lang="css" scoped>
.marco {
  max-height: 1170px;
  min-height: 1170px;
  /* border: 3px solid red ; */
}
.marco2 {
  max-height: 1270px;
  min-height: 1270px;
  /* border: 3px solid red ; */
}
.borde {
  border: 1px solid black;
}
.tabla {
  font-size: 11px;
}
input[type="checkbox"] {
  transform: scale(0.7);
}
spacer {
  min-width: 150px;
}
</style>
